<template>
  <div>
    <h2>Página Inicial</h2>
  </div>
</template>


<script>

export default {
  name: 'Home',
}
</script>
